/** USD amounts shown in gift checkout and related plan UI. */
export const GIFT_UNIT_PRICE_USD = 299;

/** Upper bound for gift plan quantity (stepper) and recipient rows in one checkout. */
export const GIFT_MAX_PLAN_QUANTITY = 10;

/** Standard annual membership price shown on plan information (non-gift). */
export const MEMBERSHIP_ANNUAL_PRICE_USD = 299;
